// initialed state
export const initialState = () => ({
	taskLog: [],
	loadingLogs: false,
	selectedTaskId: null,
	selectedTaskInfo: null,
	selectedTaskNodes: [],
	loadingSelectedTaskNodes: false,
	nodeRunData: {},
	runsByDay: {},
	runsByUser: [],
	runsByFeature: [],
	latestErrors: [],
	personalInterfacesTaskLog: {},
});

const state = initialState();

export default state;
